import auth from "@/middleware/auth";

export default [
    {
        path: "acordoFechado",
        name: "acordoFechado",
        meta: { middleware: [auth] },
        component: () => import("./AcordoFechado")
    }
];
